import { HStack, VStack } from "@chakra-ui/react";
import { KYDImageUpload, KYDInput } from "./ui";

const KYDVideoUpload = ({
  url,
  preview_src,
  onChange,
  isDisabled = false,
  createUploadUrl,
}: {
  url: string | null;
  onChange: ({
    src,
    preview_src,
  }: {
    src?: string;
    preview_src?: string;
  }) => void;
  isDisabled?: boolean;
  createUploadUrl: ({
    file,
    callback,
  }: {
    file: File;
    callback: ({ signedUrl }) => void | Promise<void | string>;
  }) => Promise<{ signedUrl: string; fileKey: string }>;
  preview_src: string | null;
}) => {
  const videoId = url?.split("v=")[1]?.split("&")[0] || "";
  const thumbnailUrl =
    preview_src || `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;

  return (
    <VStack
      w="100%"
      borderRadius="8px"
      p={3}
      bg="#F5F5F5"
      gap={3}
      alignItems="center"
      justifyContent="center"
      transition="border 0.2s ease"
    >
      {url && (
        <HStack
          borderRadius="8px"
          p={3}
          bg="#F5F5F5"
          gap={3}
          w="100%"
          alignItems="center"
          justifyContent="center"
          transition="border 0.2s ease"
        >
          <KYDImageUpload
            createUploadUrl={createUploadUrl}
            image={thumbnailUrl}
            link={url}
            onChange={(result) => {
              onChange({
                preview_src: result.cdn_url,
              });
            }}
            isDisabled={isDisabled}
          />
          {/* <VStack w="100%">

            <Button
              type="button"
              onClick={() => {
                onChange(null);
              }}
              isDisabled={isDisabled}
              border="1px solid #0000001A"
              variant="outline"
              fontWeight="400"
              colorScheme="gray"
              fontSize="13px"
              gap={2}
              borderRadius="50px"
            >
              <AddIcon color="#5D5D5D" />
              Add Image
            </Button>
            <Text fontSize="12px" color="#1A202CB2">
              Drag & drop file here
            </Text>
          </VStack> */}
        </HStack>
      )}

      <KYDInput
        label="Video"
        placeholder="Add youtube or vimeo link"
        value={url}
        onChange={(e) =>
          onChange({
            src: e.target.value,
          })
        }
      />
    </VStack>
  );
};

export default KYDVideoUpload;
